import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
/**
 * This colour has a ticket that is set to not fix.
 * @link https://polestarjira.atlassian.net/browse/PCW-6363
 */
const successStatusColor = 'rgb(6, 169, 89)';
const StatusBadgeTheme = {
    statusBadge: {
        light: {
            variants: {
                active: {
                    statusColor: successStatusColor,
                    textColor: Colors.black,
                    backgroundColor: Colors.lightGrey,
                },
                attention: {
                    statusColor: Colors.error,
                    textColor: Colors.black,
                    backgroundColor: Colors.lightGrey,
                },
                default: {
                    statusColor: withOpacity(Colors.black, Opacities.medium),
                    textColor: Colors.black,
                    backgroundColor: Colors.lightGrey,
                },
                inactive: {
                    statusColor: withOpacity(Colors.black, Opacities.low),
                    textColor: withOpacity(Colors.black, Opacities.medium),
                    backgroundColor: Colors.lightGrey,
                },
                pending: {
                    statusColor: Colors.accessibleSafetyOrange,
                    textColor: Colors.black,
                    backgroundColor: Colors.lightGrey,
                },
            },
        },
        dark: {
            variants: {
                active: {
                    statusColor: successStatusColor,
                    textColor: Colors.white,
                    backgroundColor: withOpacity(Colors.white, Opacities.xLow),
                },
                attention: {
                    statusColor: Colors.error,
                    textColor: Colors.white,
                    backgroundColor: withOpacity(Colors.white, Opacities.xLow),
                },
                default: {
                    statusColor: withOpacity(Colors.white, Opacities.medium),
                    textColor: Colors.white,
                    backgroundColor: withOpacity(Colors.white, Opacities.xLow),
                },
                inactive: {
                    statusColor: withOpacity(Colors.white, Opacities.low),
                    textColor: withOpacity(Colors.white, Opacities.medium),
                    backgroundColor: withOpacity(Colors.white, Opacities.xLow),
                },
                pending: {
                    statusColor: Colors.accessibleSafetyOrange,
                    textColor: Colors.white,
                    backgroundColor: withOpacity(Colors.white, Opacities.xLow),
                },
            },
        },
    },
};
export default StatusBadgeTheme;
